"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const icon_new_1 = __importDefault(require("../icon-new"));
exports.Option = styled_components_1.default.option ``;
const { ChevronDown } = icon_new_1.default;
const Wrapper = styled_components_1.default.div `
  position: relative;
  border-radius: 4px;
  background: ${({ theme, disabled }) => disabled ? theme.neutral.light : theme.white};
`;
const IconWrapper = styled_components_1.default.div `
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 3px;
`;
const StyledSelect = styled_components_1.default.select `
  appearance: none;
  font-size: 14px;
  border-radius: 4px;
  font-weight: 400;
  padding: 2px 24px 2px 8px;
  text-align: left;
  overflow: hidden;
  outline: none;
  text-overflow: ellipsis;
  min-width: 90px;
  height: 32px;
  white-space: nowrap;
  width: 100%;
  position: relative;
  z-index: 1;
  background-color: transparent;
`;
const RotaSelect = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement(Wrapper, { disabled: props.disabled },
        react_1.default.createElement(StyledSelect, Object.assign({}, props)),
        react_1.default.createElement(IconWrapper, null,
            react_1.default.createElement(ChevronDown, null))));
};
exports.default = RotaSelect;
